// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bank-account-add-modal-modal_card-MGYFP {
  width: 348px;
  height: 400px;
}

.bank-account-add-modal-modal_content-qKpEi {
  padding: 0px 20px;
}

.bank-account-add-modal-textField_container-DynJh {
  width: 100%;
  margin-top: 28px;
}

.bank-account-add-modal-textField_input-U2cr6 {
  height: 40px;
  font-size: 15px;
}

.bank-account-add-modal-select_container-lX897 {
  width: 100%;
  margin-top: 28px;
}

.bank-account-add-modal-select_popup-T8H1o {
  padding: 4px 0px;
}

.bank-account-add-modal-bankItem-lneYh {
  display: flex;
  align-items: center;
  padding: 8px;
}

.bank-account-add-modal-bankImage-wTahe {
  height: 24px;
}

.bank-account-add-modal-bankName-gE37p {
  margin-left: 16px;
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/bank-account-add-modal/bank-account-add-modal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB","sourcesContent":[".modal_card {\n  width: 348px;\n  height: 400px;\n}\n\n.modal_content {\n  padding: 0px 20px;\n}\n\n.textField_container {\n  width: 100%;\n  margin-top: 28px;\n}\n\n.textField_input {\n  height: 40px;\n  font-size: 15px;\n}\n\n.select_container {\n  width: 100%;\n  margin-top: 28px;\n}\n\n.select_popup {\n  padding: 4px 0px;\n}\n\n.bankItem {\n  display: flex;\n  align-items: center;\n  padding: 8px;\n}\n\n.bankImage {\n  height: 24px;\n}\n\n.bankName {\n  margin-left: 16px;\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_card": `bank-account-add-modal-modal_card-MGYFP`,
	"modal_content": `bank-account-add-modal-modal_content-qKpEi`,
	"textField_container": `bank-account-add-modal-textField_container-DynJh`,
	"textField_input": `bank-account-add-modal-textField_input-U2cr6`,
	"select_container": `bank-account-add-modal-select_container-lX897`,
	"select_popup": `bank-account-add-modal-select_popup-T8H1o`,
	"bankItem": `bank-account-add-modal-bankItem-lneYh`,
	"bankImage": `bank-account-add-modal-bankImage-wTahe`,
	"bankName": `bank-account-add-modal-bankName-gE37p`
};
export default ___CSS_LOADER_EXPORT___;
